import axios from 'axios'

const isServer = () => Object.prototype.toString
  .call(global.process) === '[object process]' || typeof window === 'undefined'

const httpRequest = (token = '') => {
  const defaultOptions = {
    xsrfHeaderName: 'x-csrf-token',
    withCredentials: true,
    headers: {
      Pragma: 'no-cache'
    },
    timeout: process.env.REQUEST_TIMEOUT
  }

  if ( isServer() ) {
    defaultOptions.headers = {
      Cookie: token ? token : null
    }
  }

  const baseUrl = isServer() ? `${process.env.BASE_URL}:${process.env.PORT}/api` : '/api'

  const instance = axios.create({
    baseURL: baseUrl
  })

  instance.interceptors.response.use(response => {
    return response
  }, error => {
    if (!error.response) {
      error.response = {}
    }
    if (!isServer()) {
      const reduxStore = __NEXT_REDUX_STORE__
      if (reduxStore && error.response.status === 401) {
        reduxStore.dispatch({ type: 'LOGOUT_SUCCESS' })
      }
    }

    return Promise.reject(error)
  })
  return {
      get: (url, options = {}) => instance.get(url, { ...defaultOptions, ...options }),
      post: (url, data, options = {}) => instance.post(url, data, { ...defaultOptions, ...options }),
      put: (url, data, options = {}) => instance.put(url, data, { ...defaultOptions, ...options }),
      delete: (url, options = {}) => instance.delete(url, { ...defaultOptions, ...options }),
  }
}

export default httpRequest



// WEBPACK FOOTER //
// ./lib/http.js